import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1 className="about-title">Sobre a Gestare</h1>
          <p className="about-subtitle">
            Seu fundador com mais de 13 anos de experiência na área suprindo a carência de serviços especializados na área médica.
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission">
        <div className="container">
          <div className="mission-content">
            <div className="mission-text">
              <h2>Nossa Missão</h2>
              <p>
                Com um compromisso constante com a qualidade e a excelência no atendimento, a Gestare Soluções
                 Contábeis está pronta para atender às demandas contábeis de seus clientes com eficiência e agilidade.
              </p>
            </div>
            <div className="mission-image">
              <div className="image-placeholder">
                <svg width="50" height="50" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="currentColor"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values">
        <div className="container">
          <h2 className="section-title">Nossos Valores</h2>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3>Transparência</h3>
              <p>Comunicação clara e honesta em todos os processos, mantendo nossos clientes sempre informados.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                  <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3>Agilidade</h3>
              <p>Processos otimizados e tecnologia de ponta para entregas rápidas e eficientes.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3>Segurança</h3>
              <p>Proteção total dos dados e informações dos nossos clientes com os mais altos padrões de segurança.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                  <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M23 21v-2a4 4 0 00-3-3.87" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M16 3.13a4 4 0 010 7.75" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3>Excelência</h3>
              <p>Compromisso com a qualidade superior em todos os serviços prestados e relacionamentos.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="team">
        <div className="container">
          <h2 className="section-title">Nossa Equipe</h2>
          <div className="team-content">
            <div className="team-text">
              <h3>Profissionais Qualificados</h3>
              <p>
                Nossa equipe é formada por contadores, analistas e especialistas 
                altamente qualificados, com vasta experiência no mercado e 
                constantemente atualizados com as últimas mudanças na legislação.
              </p>
              <ul className="team-features">
                <li>Contadores CRC ativos</li>
                <li>Especialização na área médica</li>
                <li>Atualização constante em legislação</li>
              </ul>
            </div>
            <div className="team-stats">
              <div className="team-stat">
                <h4>5+</h4>
                <p>Profissionais</p>
              </div>
              <div className="team-stat">
                <h4>13+</h4>
                <p>Anos de Experiência na área</p>
              </div>
              <div className="team-stat">
                <h4>100%</h4>
                <p>Qualificados</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* History Section */}
      <section className="history">
        <div className="container">
          <h2 className="section-title">Nossa História</h2>
          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-year">2019</div>
              <div className="timeline-content">
                <h3>Fundação</h3>
                <p>Início das atividades com foco em profissionais da saúde.</p>
              </div>
            </div>
            
            <div className="timeline-item">
              <div className="timeline-year">2020</div>
              <div className="timeline-content">
                <h3>Expansão</h3>
                <p>Ampliação da equipe e implementação de novas soluções.</p>
              </div>
            </div>
            
            <div className="timeline-item">
              <div className="timeline-year">2021</div>
              <div className="timeline-content">
                <h3>Digitalização</h3>
                <p>Migração completa para processos digitais e atendimento remoto.</p>
              </div>
            </div>
            
            <div className="timeline-item">
              <div className="timeline-year">2025</div>
              <div className="timeline-content">
                <h3>Inovação</h3>
                <p>Lançamento de novas soluções e atendimento a mais profissionais da saúde.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
